import { render, staticRenderFns } from "./PreOrderCustomButton.vue?vue&type=template&id=80312fe8&"
import script from "./PreOrderCustomButton.vue?vue&type=script&lang=js&"
export * from "./PreOrderCustomButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports